import React, { useState, useEffect, useRef } from 'react';
import Nav from '../Nav';
import Footer from '../Footer';
import Content from '../Content';
import { Outlet, useLocation } from 'react-router-dom';
import '../../assets/scss/bootstrapExtended.scss';
import './layout.scss';
import '../../styles/globalStyle.scss';
import { GlobalProvider } from '../../globalContext';
import 'react-toastify/dist/ReactToastify.css';
import ChatbotContainer from '../Chatbot';
import { useIsChatBotEnabledMutation } from '../../features/authentication/chatbotApiSlice';

const Layout = () => {
  const [conditionalRendering, setConditionalRendering] = useState(false);
  const [isChatBotEnabled, setIsChatBotEnabled] = useState(null);
  const [checkIsChatBotEnabled] = useIsChatBotEnabledMutation();
  const contentRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (contentRef.current) contentRef.current.scrollTo(0, 0);
  }, [pathname]);

  const conditionalRenderingData = () => {
    const url = window.location.href;
    const endString = url.substr(url.lastIndexOf('/') + 1);
    endString === 'standardPrinting'
      ? setConditionalRendering(true)
      : setConditionalRendering(false);
  };

  useEffect(() => {
    conditionalRenderingData();
  }, [window.location.href]);

  useEffect(() => {
    const loadIsChatbotEnabled = async () => {
      try {
        const response = await checkIsChatBotEnabled().unwrap();
        setIsChatBotEnabled(response);
      } catch (error) {
        console.warn('Could not resolve chatbot enabled status:', error);
        setIsChatBotEnabled(false);
      }
    };

    loadIsChatbotEnabled();
  }, [checkIsChatBotEnabled]);

  return (
    <React.Fragment>
      <GlobalProvider>
        {!conditionalRendering ? (
          <>
            <Nav />
            <Content ref={contentRef}>
              <div className="content-wrapper">
                <Outlet />
              </div>
              <Footer />
            </Content>
            {isChatBotEnabled && <ChatbotContainer />}
          </>
        ) : (
          <Outlet />
        )}
      </GlobalProvider>
    </React.Fragment>
  );
};

export default Layout;
